import z from 'app/common/z';
import Errors, { resourceNames } from 'app/errors';
import { fetchJson, getJsonWithAccountId } from 'app/common/fetch';

const Data = {
  runZap(zapId) {
    return fetchJson(`${z.cfg.api}/zaps/${zapId}/run`, {
      method: 'POST',
      data: '{}',
    }).catch(response => {
      throw new Errors.DataPostError({
        resource: resourceNames.zapRun,
        response,
      });
    });
  },

  runZapStatus(zapId) {
    return fetchJson(`${z.cfg.api}/zaps/${zapId}/run/status`)
      .then(data => data.messages)
      .catch(response => {
        throw new Errors.DataGetError({
          resource: resourceNames.zapRunStatus,
          response,
        });
      });
  },

  loadHeldReasons(accountId) {
    return getJsonWithAccountId(accountId, `${z.cfg.api}/stream/held`).catch(
      response => {
        throw new Errors.DataGetError({
          resource: resourceNames.heldReasons,
          response,
        });
      }
    );
  },
};

export default Data;
